import { render, staticRenderFns } from "./RemainingAmountMatrix.vue?vue&type=template&id=4d37e104"
import script from "./RemainingAmountMatrix.vue?vue&type=script&lang=js"
export * from "./RemainingAmountMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports